<template>
    <div class="canvas-layout" v-if="canvas2_is_ready">
        <div class="header">
            <div class="left">
                <div class="logo">
                    <img src="/images/dfc-logo.svg" alt="Design for Change USA">
                </div>
                <!-- <div class="team team-desktop">
                    <div class="team-name"><strong>Team:</strong> {{ team?.name }}</div>
                    <div class="members">
                        <div class="member" v-for="member in team.members"
                                    :key="member.id">
                            <name-icon :value="member"/>
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="center">
                <div class="switch" v-if="$page.props.canvas_editable">
                    <inertia-link v-if="stage"
                        :href="route('student.canvas2.activities', { uuid, stage, ...global_url_params })" class="option"
                        :class="{ active: page === 'activities' }">Activities</inertia-link>
                    <inertia-link :href="route('student.canvas2.show', { uuid, ...global_url_params })" class="option"
                        :class="{ active: page === 'canvas' }">Canvas</inertia-link>
                </div>
            </div>
            <div class="right" v-if="$page.props.canvas_editable">
                <div class="old-canvas-desktop">
                    <inertia-link :href="route('student.canvas.show', { uuid, ...global_url_params })">
                        <div class="link-btn">Old Canvas</div>
                    </inertia-link>
                </div>

                <div class="menu">
                    <a href="#" class="bars" @click="toggleMenu()">=</a>
                    <teleport to="body" v-if="menu.enabled">
                        <div class="stage-map" @click.stop.prevent="menu.enabled = false">
                            <div class="stage-map-inner" @click.stop.prevent>
                                <!--                                <pre>{{ {project} }}</pre>-->
                                <div class="top-bar">
                                    <button class="close" @click="toggleMenu()">X</button>
                                </div>
                                <div class="old-canvas-mobile">
                                    <inertia-link :href="route('student.canvas.show', { uuid, ...global_url_params })">
                                        <div class="link-btn">Old Canvas</div>
                                    </inertia-link>
                                </div>
                                <div class="content">
                                    <div class="project-info">
                                        <div class="item">
                                            <strong>Team:</strong> {{ team?.name }}
                                            <div class="members">
                                                <div class="member" v-for="member in team.members" :key="member.id">
                                                    <name-icon :value="member" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="item"><strong>Project:</strong> {{ project?.name }}</div>
                                        <div class="item"><strong>Goal:</strong> {{ goal?.name }}</div>
                                    </div>
                                    <div class="progress-map">
                                        <div class="bottom-layer">
                                            <div v-for="(s, index) in stages_reversed" :key="s.slug" class="map-item"
                                                :class="{ active: isActive(s, index) }">
                                                <map-progress-semi-circle class="semi-circle" :color="s.config.color" />
                                            </div>
                                        </div>
                                        <div class="top-layer">
                                            <div v-for="(s, index) in stages_reversed" :key="s.slug" class="map-item"
                                                :class="{ active: isActive(s, index) }">
                                                <map-progress-arrow class="arrow" :whiten="isActive(s, index) ? 0 : .7"
                                                    :color="s.config.color" />
                                                <div class="icon">
                                                    <img :src="s.slug === 'intro' ? `/images/icons/new/icon-warmup.svg` : `/images/icons/new/icon-${s.slug}.svg`"
                                                        alt="">
                                                </div>
                                                <div class="lock">
                                                    <img src="/images/canvas2/lock.svg">
                                                </div>
                                            </div>
                                            <div class="project-goal" v-if="goal?.id">
                                                <img class="goal-icon" :src="goal?.icon" :alt="goal?.name">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="progress-map-legend">
                                        <div v-for="(s, index) in stages_reversed" :key="s.slug" class="legend"
                                            :class="{ active: isActive(s, index) }">
                                            <!--                                            {{ isActive(s, index) ? 'active' : 'inactive' }}-->
                                            <div class="line" :style="{ 'border-left-color': s.config.color }"></div>
                                            <div class="name" :style="{ color: s.config.color }">
                                                {{ stages_reversed.length - index }}. {{ s.config.name }}
                                            </div>
                                            <div class="info">
                                                <strong :style="{ color: s.config.color }">
                                                    2
                                                </strong> of
                                                <strong :style="{ color: s.config.color }">
                                                    {{ getPathActivitiesOnlyByStage(s.slug).length }}
                                                </strong> activities completed
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="close">

                                </div>
                            </div>
                        </div>
                    </teleport>
                </div>
            </div>
        </div>
        <slot></slot>
        <div class="footer">
            <img src="/images/dfc-logo.svg" class="logo" alt="Design for Change USA">
            <div class="inner">
                <div class="container-fluid">
                    ©2014 - {{ year }} Design for Change USA. All Rights Reserved.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NameIcon from "@/Components/Team/NameIcon";
import MapProgressArrow from "@/Others/Canvas2/MapProgressArrow";
import MapProgressSemiCircle from "@/Others/Canvas2/MapProgressSemiCircle";
import utils from "@/mixins/utils";
import { mapGetters } from "vuex";

export default {
    name: "CanvasLayout",
    components: { MapProgressSemiCircle, MapProgressArrow, NameIcon },
    mixins: [utils],
    props: ['page', 'stage'],
    data() {
        return {
            year: new Date().getFullYear(),
            menu: {
                enabled: false,
            },
        }
    },

    computed: {

        ...mapGetters('canvas2', ['stages', 'team', 'goal', 'uuid', 'canvas2_is_ready', 'getPathActivitiesOnlyByStage']),

        // _$$path(){
        //     return this.pathRepo.fragments;
        // },
        // _$$canvas(){
        //     return this.canvasRepo.fragments;
        // },
        //
        // stages(){
        //     return this._$$path?.stages?.map(slug => ({
        //         slug,
        //         config: this._$$path[`stage_${slug}_config`],
        //     }));
        // },


        stages_reversed() {
            return this.stages.slice().reverse();
        },

    },

    methods: {

        toggleMenu() {
            this.menu.enabled = !this.menu.enabled;
        },

        isActive(stage, index) {
            const active_to = 1;
            return index >= this.stages.length - 1 - active_to;
        }

    },

    mounted() {

    }

}
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 1rem;
    background: white;
    position: sticky;
    top: 0;
    z-index: 90;
    height: 87px;

    .left {
        width: 40%;
        display: flex;
        align-items: center;
        gap: 1rem;
    }

    .center {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .right {
        display: flex;
        justify-content: flex-end;
        width: 40%;
        gap: 30px;
    }

    @media (max-width: 460px) {
        .left, .right {
            width: auto;
        }
    }

    .menu {
        display: flex;
        align-items: center;
        gap: 20px;
    }

    @media (max-width: 768px) {
        .old-canvas-desktop {
            display: none;
        }
    }

    .logo {
        flex-shrink: 0;

        img {
            width: 100%;
            max-width: 80px;
            height: auto;
            @media (max-width: 650px) {
                max-width: 70px;
            }
        }
    }

}

// @media (min-width: 768px) and (max-width: 1199px){
//     .header{

//         // .sub-header {
//         //     flex-wrap: wrap;
//         //     .left {
//         //         flex-basis: 100%;
//         //         width: 100%;
//         //     }

//         //     .center {
//         //         flex-basis: 100%;
//         //         width: 100%;
//         //     }
//         //     .right {
//         //         flex-basis: 100%;
//         //         width: 100%;
//         //     }
//         // }

//         .logo{
//             margin-right: 1rem;

//             img{
//                 width: 100%;
//                 max-width: 80px;
//                 height: auto;
//             }
//         }

//     }
// }

// .team{
//     display: flex;
//     align-items: center;

//     strong{
//         color: $imagine;
//     }

//     .members{
//         display: flex;
//         margin-left: 1rem;

//         .member{
//             margin-left: -1rem;
//             transition: padding .3s;

//             &:first-child{
//                 margin-left: 0;

//                 &:hover{
//                     padding: 0 1.1rem 0 0;
//                 }
//             }

//             &:last-child{
//                 &:hover{
//                     padding: 0 0 0 1.1rem;
//                 }
//             }

//             &:hover{
//                 padding: 0 1.1rem;
//             }

//         }
//     }
// }

@media (min-width: 768px) and (max-width: 1199px) {
    .team {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .members {
            margin-left: 0rem;
        }
    }
}

@media (max-width: 1050px) {
    .team {
        .team-name {
            font-size: 14px;
        }
    }
}

@media (max-width: 991px) {
    .team-desktop {
        display: none;
    }
}

.switch {
    background: #C1C1C1;
    box-shadow: rgba(black, 0.1) 0 3px 5px inset;
    border-radius: 2rem;
    display: inline-flex;
    border: #D9D9D9 solid 1px;

    .option {
        padding: 0.4rem 1rem;
        border-radius: 2rem;
        display: block;
        color: #9D9D9D;
        text-transform: uppercase;
        text-decoration: none;
        font-weight: $font-weight-bold;

        &.active {
            background: white;
            color: $feel;
        }

        @media (max-width: 650px) {
            font-size: 14px;

            @media (max-width: 460px) {
                font-size: 8px;
            }
        }
    }
}

.footer {
    text-align: center;

    .logo {
        height: 6rem;
        width: auto;
    }

    .inner {
        background: url("/images/canvas2/footer-bg.svg") no-repeat center top / cover;
        padding: 6rem 0 4rem;
    }
}

.stage-map {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(black, 0.5);
    backdrop-filter: blur(5px);
    z-index: 999;
    overflow-y: auto;

    .stage-map-inner {
        background: white;
        box-shadow: rgba(black, .2) 0 5px 25px;
    }

    .top-bar {
        padding: .6rem;
    }

    .old-canvas-mobile {
        display: none;

        @media (max-width: 768px) {
            display: flex;
            padding: 0 2rem;
            margin: 1rem 0 0.4rem 0;
        }
    }

    .content {
        max-width: 1200px;
        padding: 0 1rem;
        margin: 0 auto;
    }

    .project-info {
        font-size: 1.56rem;
        font-weight: $font-weight-bold;
        display: flex;
        align-items: self-start;
        justify-content: center;
        flex-direction: column;

        @include media-breakpoint-up(lg) {
            flex-direction: row;
            align-items: center;
        }

        .item {
            padding: .4rem 1rem;

            @include media-breakpoint-up(lg) {
                border-right: darken($light, 10%) solid 1px;
            }

            @media (max-width: 650px) {
                font-size: 18px;
            }

            &:last-child {
                border-right: none;
            }

            .members {
                display: flex;
                margin-left: 1rem;
                font-size: 1rem;

                .member {
                    margin-left: -1rem;
                    transition: padding .3s;

                    &:first-child {
                        margin-left: 0;

                        &:hover {
                            padding: 0 1.1rem 0 0;
                        }
                    }

                    &:last-child {
                        &:hover {
                            padding: 0 0 0 1.1rem;
                        }
                    }

                    &:hover {
                        padding: 0 1.1rem;
                    }

                }
            }
        }

        strong {
            color: $feel;
        }
    }

    .progress-map {
        position: relative;
        padding: 0 0 240px;
        margin-top: 60px;

        .top-layer {
            position: absolute;
            top: 1px;
            left: 0;
            right: 0;
            display: flex;
            flex-direction: row-reverse;
            padding-left: 7.2%;

            .project-goal {
                position: absolute;
                right: 0;
                top: 100%;
                margin-top: 1.2rem;

                img {
                    width: 5rem;
                    height: auto;
                    border-radius: 0.3rem;
                }
            }

            .map-item {
                flex: 1 1 auto;
                margin-left: -7.2%;
                transform-origin: 50% 75%;
                transform: scale(1);
                position: relative;

                //.arrow{
                //    filter: brightness(350%) contrast(95%) opacity(1);
                //}

                &.active {
                    //.arrow{
                    //    filter: none;
                    //}

                    .icon {
                        opacity: 1;
                    }

                    .lock {
                        display: none;
                    }
                }

                &:nth-child(even) {
                    transform: scale(1, -1);

                    .icon {
                        transform: translate(-60%, 0) scale(1, -1);
                    }

                    .lock {
                        transform: translate(-70%, 35%) scale(1, -1);
                    }
                }

                .icon {
                    opacity: .25;
                }


                .icon,
                .lock {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    width: 30%;
                    transform: translate(-60%, 0);

                    img {
                        width: 100%;
                        height: auto;
                    }
                }

                .lock {
                    transform: translate(-70%, 40%);
                    width: 15%;
                }
            }
        }

        .bottom-layer {
            display: flex;
            flex-direction: row-reverse;
            padding-left: 5.5%;
            padding-right: 1.7%;

            .map-item {
                flex: 1 1 auto;
                margin-left: -5.3%;
                transform-origin: 50% 100%;
                transform: scale(1);

                .semi-circle {
                    filter: opacity(5%);
                }

                &.active {
                    .semi-circle {
                        filter: opacity(10%);
                    }
                }

                &:nth-child(odd) {
                    transform: scale(1, -1);
                }
            }
        }

    }

    .progress-map-legend {
        display: flex;
        flex-direction: row-reverse;
        margin-left: -.5rem;
        margin-right: -.5rem;
        padding: 0 3rem;

        .legend {
            flex-grow: 1;
            text-align: center;
            padding: 0 .5rem 3rem .5rem;
            position: relative;
            opacity: .35;

            &.active {
                opacity: 1;
            }

            .line {
                position: absolute;
                left: 50%;
                bottom: 100%;
                transform: translate(-50%, -1rem);
                height: 60px;
                border-left: #000 solid 1px;
            }

            .name {
                font-size: 21px;
                font-weight: $font-weight-bold;
                text-transform: uppercase;
            }

            // .info{

            // }
        }

        @media (max-width: 768px) {
            flex-direction: column-reverse;
            gap: 60px;
        }
    }

}

.bars {
    font-size: 3rem;
    line-height: 0;
    @media (max-width: 650px) {
        font-size: 2rem;
    }
}

.link-btn {
    background-color: rgb(0, 178, 227);
    color: white;
    padding: 7px 15px;
    border-radius: 7px;
    border: none;
    font-weight: 600;
    transition-duration: 0.3s;
}

.link-btn:hover {
    opacity: 0.8;
}</style>
